// extracted by mini-css-extract-plugin
module.exports = {"description-list":"_2LsJVS01ye","descriptionList":"_2LsJVS01ye"};
    if(module.hot) {
      // 1597843272709
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  